import type { AuthRepository } from '@/domain/repositories/auth.repository'
import { container } from '@/infrastructure/di/container'

/**
 * Use-cases autentikasi. Menerima repository (default dari container) agar
 * mudah di-test. Orkestrasi login 2-langkah dipegang oleh auth store.
 */
const repo: AuthRepository = container.authRepository

export const authUseCases = {
  login: (username: string, password: string, repository: AuthRepository = repo) =>
    repository.login(username, password),

  selectTenant: (loginToken: string, tenantId: string, repository: AuthRepository = repo) =>
    repository.selectTenant(loginToken, tenantId),

  me: (repository: AuthRepository = repo) => repository.me(),

  logout: (refreshToken?: string, repository: AuthRepository = repo) =>
    repository.logout(refreshToken),
}
